import { createStore as _createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import reducer from './reducer';
import sagas from './sagas';
import { createTracker } from 'redux-segment';

let store;

export function createStore(history, data) {

  const reduxRouterMiddleware = routerMiddleware(history);
  const sagaMiddleware = createSagaMiddleware();
  const middleware = [ reduxRouterMiddleware ];

  middleware.push(sagaMiddleware);

  // `redux-segment` tracker for Mixpanel events
  //   please see `Views.Analytics#registerSuperProperties` in coffee/views/analytics.coffee;
  //   that method injects metadata into the global `analytics` Object upon page load.
  //   `redux-segment` uses the global `analytics`,
  //   so it automatically inherits all of the Frontend Mixpanel metadata goodness
  const tracker = createTracker();

  const finalCreateStore = applyMiddleware(...middleware, tracker)(_createStore);

  store = finalCreateStore(reducer, data);

  sagaMiddleware.run(sagas);

  return store;
}
